import Axios from "../../Config/API";
import { IMotivoInadimplencia } from "../../../Interfaces/Cobranca/MotivoInadimplencia/MotivoInadimplenciaInterface";
import Service from "../../Service";

export async function ListarMotivoInadimplenciaService() {
    return Service(
        Axios.get<Array<IMotivoInadimplencia>>(
            `/cobranca/motivoinadimplencia/listarmotivoinadimplencia`
        )
    );
}
export async function GetMotivoInadimplenciaService(
    IDMotivoInadimplencia: number
) {
    return Service(
        Axios.get(
            `/cobranca/motivoinadimplencia/getmotivoinadimplencia?IDMotivoInadimplencia=${IDMotivoInadimplencia}`
        )
    );
}

export async function InserirMotivoInadimplenciaService(
    requestBody: IMotivoInadimplencia
) {
    return Service(
        Axios.post(
            `/cobranca/motivoinadimplencia/inserirmotivoinadimplencia`,
            requestBody
        )
    );
}

export async function AtualizarMotivoInadimplenciaService(
    requestBody: IMotivoInadimplencia
) {
    return Service(
        Axios.put(
            `/cobranca/motivoinadimplencia/atualizarmotivoinadimplencia`,
            requestBody
        )
    );
}

export async function DeletarMotivoInadimplenciaService(
    IDMotivoInadimplencia: number
) {
    return Service(
        Axios.delete(
            `/cobranca/motivoinadimplencia/deletarmotivoinadimplencia?IDMotivoInadimplencia=${IDMotivoInadimplencia}`
        )
    );
}
